import React from "react";
import { Helmet } from "react-helmet";
import Icon from "../../components/AppIcon";
import ResponsiveTopNavigation from "../../components/navigation/ResponsiveTopNavigation";
import Footer from "components/Footer";

const TermsAndConditionsPage = () => {

  const sectionTitle = (text) => (
    <h2 className="text-primary font-bold text-lg md:text-xl mb-2 font-[cairo]">{text}</h2>
  );

  const sectionText = (text) => (
    <p className="text-gray-800 text-sm md:text-base leading-relaxed whitespace-pre-line">
      {text}
    </p>
  );

  return (
    <>
      <Helmet>
        <title>الشروط والأحكام</title>
      </Helmet>

      <ResponsiveTopNavigation />

      <main className="min-h-screen mt-16 bg-white px-4 md:px-8 py-6 md:py-8 font-[cairo]">
        {/* Page Header */}
       

        {/* Content */}
        <div className="max-w-3xl mx-auto space-y-6">

          {/* Section 1 */}
          <div>
            {sectionTitle("الموافقة والشروط العامة")}
            {sectionText(
              "باستخدام هذا التطبيق، فإنك توافق على جميع شروط الاستخدام المذكورة.\n" +
              "• نحتفظ بحق تعديل الشروط بمرور الوقت.\n" +
              "• يجب إنشاء حساب شخصي للمتابعة.\n" +
              "• الموافقة والتحقق من الهوية إلزامي.\n" +
              "• تقديم معلومات صحيحة ومحدثة.\n" +
              "• دفع المبالغ المستحقة قبل تسليم الطلب.\n" +
              "• يمكن إلغاء الطلب قبل التجهيز فقط.\n" +
              "• نتخذ إجراءات أمان لحماية البيانات.\n" +
              "• الالتزام بالقوانين المعمول بها.\n" +
              "• التواصل مع الدعم الفني عند الحاجة.\n" +
              "• تحديث سياسة الاستخدام مع إشعار المستخدمين.\n" +
              "• التواصل عبر واتساب في حالة الاستفسار."
            )}
          </div>

          {/* Section 2 */}
          <div>
            {sectionTitle("الشروط والأحكام التفصيلية")}
            {sectionText(
              "1- إتمام التسجيل يُعد قبولاً كاملاً بالشروط.\n" +
              "2- دور مقدم الخدمة هو التوسط في التوصيل.\n" +
              "3- جميع بيانات المستخدم تخضع لسياسة الخصوصية.\n" +
              "4- إتمام الطلب التزام مالي كامل.\n" +
              "5- تأكيد الاستلام يُخلي مسؤولية مقدم الخدمة.\n" +
              "6- يمنع التعرض لأي موظف.\n" +
              "7- جودة المنتجات مسؤولية الجهات العارضة."
            )}
          </div>

        </div>
      </main>
      {/* <Footer/> */}
    </>
  );
};

export default TermsAndConditionsPage;